import { render, staticRenderFns } from "./daichuli.vue?vue&type=template&id=56ad914b&scoped=true&"
import script from "./daichuli.vue?vue&type=script&lang=js&"
export * from "./daichuli.vue?vue&type=script&lang=js&"
import style0 from "./daichuli.vue?vue&type=style&index=0&id=56ad914b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ad914b",
  null
  
)

export default component.exports